// returns pairs like [index, value]
export default function values() {
  var length = this.length;
  var result = new Array(length);
  for (var i = 0; i < length; i++) {
    result[i] = [i, this[i]];
  }
  return result;
}